import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../admin.service';
import { ErrorGuides } from '../../shared/models/error-guides';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { state } from '@angular/animations';

@Component({
  selector: 'app-manage-error-guides',
  templateUrl: './manage-error-guides.component.html',
  styleUrls: ['./manage-error-guides.component.scss']
})
export class ManageErrorGuidesComponent implements OnInit {

  public displayedColumns: string[] = [];
  public errorGuidesDataSource = new MatTableDataSource([]);
  public errorGuideDetails = { from: 'admin', edit: true, delete: true };

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private adminService: AdminService, private router: Router) {
    this.displayedColumns = ['code', 'notes', 'comments', 'display', 'screen', 'platform', 'tdPR_SP', 'feedback',
      'feature', 'updatedBy', 'message.solution', 'message.contentTCI', 'message.effect', 'message.contentTMNA',
      'message.description', 'message.cause', 'message.shortDescription', 'message.diagnostic', 'action'];
  }

  ngOnInit() {
    this.getAllErrorGuides();
  }

  getAllErrorGuides() {
    this.adminService.getAllErrorMessages().subscribe((response: any) => {
      this.errorGuidesDataSource = JSON.parse(response);
      this.errorGuidesDataSource.paginator = this.paginator;
      setTimeout(() => {
        this.errorGuidesDataSource.sort = this.sort;
        this.errorGuidesDataSource.paginator = this.paginator;
      })
    });
  }

  editErrorGuide(errorGuide: ErrorGuides) {
    this.router.navigateByUrl('/admin/add-error-guides', { state: { errorGuide: errorGuide } });
  }


}

